/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { selectWhatsAppMessages } from "../../../redux/whatsAppSlice";
import { useSelector } from "react-redux";
// chakra imports

export function SidebarLinks(props) {
  const messages = useSelector(selectWhatsAppMessages);

  // Chakra color mode
  let location = useLocation();

  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl"
      ) {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className="relative mb-3 flex hover:cursor-pointer ">
              <li
                className="my-[3px] flex cursor-pointer items-center px-8 "
                key={index}
              >
                <span
                  className={`${
                    activeRoute(route.path) === true
                      ? "font-bold text-brand-500 dark:text-white "
                      : " font-semibold text-gray-500 dark:text-white dark:hover:text-white"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <div className="relative flex">
                  <p
                    className={`leading-1 ml-4 flex hover:text-black dark:hover:text-white ${
                      activeRoute(route.path) === true
                        ? "font-bold text-navy-700 dark:text-white "
                        : " font-semibold text-gray-500 "
                    }`}
                  >
                    {route.name}
                  </p>
                  {route.name === "WhatsApp" && (
                    <span
                      className={`relative -top-2 ${
                        messages.length > 0 ? "text-red-500" : ""
                      }`}
                    >
                      {messages.length}
                    </span>
                  )}
                </div>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
